import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams, TenderIdParams } from 'types/api'
import { ITenderContactPerson } from 'types/tender/tenderContactPersons'

export const tenderContactPeopleApi = createApi({
  reducerPath: 'contactPeople',
  baseQuery,
  tagTypes: ['ContactPeople'],
  endpoints: (builder) => ({

    tenderContactPeople: builder.query<ITenderContactPerson[], TenderIdParams>({
      query: ({ tenderId }) => ({
        url: '/contact-people',
        params: {
          tenderId,
        },
      }),
      providesTags: ['ContactPeople'],
    }),

    tenderContactPerson: builder.query<ITenderContactPerson, IdParams>({
      query: ({ id }) => `/contact-people/${id}`,
    }),

    createTenderContactPerson: builder.mutation<
      ITenderContactPerson,
      Partial<ITenderContactPerson>
    >({
      query: (body) => ({
        url: '/contact-people',
        body,
        method: 'post',
      }),
      invalidatesTags: ['ContactPeople'],
    }),

    updateTenderContactPerson: builder.mutation<
      ITenderContactPerson,
      Partial<ITenderContactPerson>
    >({
      query: (body) => ({
        url: `/contact-people/${body.id}`,
        body,
        method: 'put',
      }),
      invalidatesTags: ['ContactPeople'],
    }),
    
    deleteTenderContactPerson: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/contact-people/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['ContactPeople'],
    }),
  }),
})

export const {
  useTenderContactPeopleQuery,
  useCreateTenderContactPersonMutation,
  useDeleteTenderContactPersonMutation,
  useTenderContactPersonQuery,
  useUpdateTenderContactPersonMutation,
} = tenderContactPeopleApi
